import { useT } from "../i18n/index.js";
import { useState } from "react";
import { comparisonRows } from "./comparison.js";
import type { UnitView } from "./types.js";

const format = (key: string, value: number) => key === "intervalTicks" ? `${(value / 10).toFixed(1)} s` : key === "crit" ? `${(value * 100).toFixed(1)}%` : key === "critDmg" ? `×${value.toFixed(2)}` : Number(value.toFixed(2)).toLocaleString();

export function UnitStatsComparison({ before, after, compact = false }: { before: UnitView; after: UnitView; compact?: boolean }) {
  const t = useT();
  const [all, setAll] = useState(false);
  const rows = comparisonRows(before, after);
  return <><table className="unit-comparison-table" data-testid="unit-stats-comparison">
    <thead><tr><th>{t("units.compare.stat")}</th><th>{t("units.compare.current")}</th><th>{t("units.compare.after")}</th><th>{t("units.compare.change")}</th></tr></thead>
    <tbody>{rows.filter(row => !compact || all || row.delta !== 0 || row.key === "power").map((row) => <tr key={row.key} data-testid={`compare-${row.key}`} data-direction={row.direction}>
      <th>{t(`units.compare.stat.${row.key}`)}</th><td>{format(row.key, row.before)}</td><td>{format(row.key, row.after)}</td>
      <td className={`comparison-${row.direction}`}>{row.delta === 0 ? "—" : `${row.delta > 0 ? "+" : "−"}${format(row.key, Math.abs(row.delta))}`}</td>
    </tr>)}</tbody>
  </table>{compact ? <label className="compare-all-toggle"><input type="checkbox" checked={all} onChange={event => setAll(event.target.checked)} />{t("units.compare.allStats")}</label> : null}</>;
}
